import { createSlice } from "@reduxjs/toolkit";

import { CustomEventState } from "@/types/customEvent";

import { RootState } from "@/redux";

import { ScrapeRequest } from "@/pages/Private/pages/CustomEvent/schema/scrapeRequest";

import { customEventApi } from "./customEvent.api";

const initialState: CustomEventState = {
	customEvents: [],
	scrapeRequestsByCustomEvent: {},
};

export const customEventSlice = createSlice({
	name: "customEvent",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			customEventApi.endpoints.getCustomEvents.matchFulfilled,
			(state, { payload }) => {
				state.customEvents = payload.data;
			}
		);

		// Bucketed per source and filed under the id it was *requested for* — a single bucket would
		// render the previously fetched source whenever RTK Query serves a warm cache entry.
		builder.addMatcher(
			customEventApi.endpoints.getScrapeRequests.matchFulfilled,
			(state, { payload, meta }) => {
				state.scrapeRequestsByCustomEvent[meta.arg.originalArgs] = payload;
			}
		);
	},
});

export const customEventReducer = customEventSlice.reducer;
export const customEventSelector = (state: RootState) => state[customEventSlice.name];

/** Every delivery of a source, newest request first. */
export const scrapeRequestsSelector =
	(customEventId?: number) =>
	(state: RootState): ScrapeRequest[] =>
		(customEventId && state[customEventSlice.name].scrapeRequestsByCustomEvent[customEventId]) ||
		[];
